export function JsTimeToUnixtime(time: Date): number {
  return time ? Math.round(time.getTime() / 1000) : null;
}

export function UnixtimeToJsTime(time: number): Date {
  return time ? new Date(time * 1000) : null;
}
